const actionLabels = {
  returnToLms: 'Go to Login',
  gotoLms: 'Go to Canvas',
  contactSupport: 'Contact Support',
  confirm: 'OK, got it',
  ok: 'Got it'
};

export default actionLabels;
